<template>
  <a class="x-mt-tiny xtotop" :class="{xactive:visible}" @click="toTopHandler"><i class="twui-ico xtotop"></i><span>返回顶部</span></a>
</template>

<script>
  export default {
    name: 'twTotop',
    data: function () {
      return {
        visible: false
      }
    },
    methods: {
      scrollHandler: function () {
        let scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
        if (scrollTop > 300) {
          this.visible = true
        } else {
          this.visible = false
        }
      },
      toTopHandler: function () {
        let scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
        let distance = scrollTop / 30

        let toScroll = function () {
          scrollTop -= distance
          window.scrollTo(0, scrollTop)

          if (scrollTop < 0) {
            return
          } else {
            setTimeout(toScroll, 10)
          }
        }

        setTimeout(toScroll, 10)
      }
    },
    mounted: function () {
      window.addEventListener('scroll', this.scrollHandler)
    },
    dostroyed: function () {
      window.removeEventListener('scroll', this.scrollHandler)
    }
  }
</script>




// WEBPACK FOOTER //
// tw-totop.vue?7b22b8a0